import OrigBsPopoverElement from 'ember-bootstrap/components/bs-popover/element';

export default class BsPopoverElement extends OrigBsPopoverElement {
  offset = [0, 8];
}
